import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Sidebar } from './Sidebar';
import { Menu } from 'lucide-react';

// Version du backoffice - BUG-6 fix: centralisé sur Build 304
const BACKOFFICE_VERSION = "v26/02 - Build 304";

export const Layout = () => {
  // State pour toggle sidebar sur mobile
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50 safe-area-top overflow-hidden">
      {/* Overlay mobile - ferme la sidebar au clic */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar avec props pour mobile */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content - pas de marge sur mobile, ml-64 sur desktop */}
      <main className="flex-1 md:ml-64 min-h-screen overflow-y-auto overflow-x-hidden">
        {/* Hamburger menu - visible uniquement sur mobile */}
        <button
          className="md:hidden fixed top-4 left-4 z-50 p-3 bg-white rounded-xl shadow-lg border border-gray-200 hover:bg-gray-50 active:scale-95 transition-all"
          onClick={() => setSidebarOpen(true)}
          aria-label="Ouvrir le menu"
        >
          <Menu className="w-6 h-6 text-gray-700" />
        </button>

        <Outlet />
      </main>

      {/* Version du backoffice - coin bas droite */}
      <div
        className="fixed bottom-3 right-4 text-xs text-gray-400 bg-white/90 px-3 py-1 rounded-xl shadow-sm z-50"
      >
        {BACKOFFICE_VERSION}
      </div>
    </div>
  );
};
